import React from 'react';
import { Box } from '@chakra-ui/react';
import styled from '@emotion/styled';
import type { IBookingSessionType } from 'client_react/booking/types';
import { useClientApiFetch } from 'client_react/bootstrap';
import { useBrand } from '../hooks/BrandContext';
import { useBrandHomepage } from '../hooks/BrandHomepageContext';
import BrandLogo from './BrandLogo';
import Nav from './Nav';

const HeaderContainer = styled(Box)`
    padding: 0 20px 40px 20px;
    top: 0;
    position: static;
    text-align: center;
    p {
        font-family: 'OpenSans Regular';
        color: #a5a5a5;
    }
`;

interface BookingSessionTypeResponse {
    items: IBookingSessionType[];
}

const Header: React.FC = () => {
    const brandData = useBrandHomepage();
    const { name: brandName } = useBrand();
    const { enableAboutPage, enableContactForm: contactFormEnabled, showBookingPage } = brandData;

    // Fetch public booking session types to determine if booking should be shown
    const { response: bookingSessionTypesResponse } = useClientApiFetch<BookingSessionTypeResponse>(
        `booking-session-type`,
        {
            enabled: showBookingPage // Only fetch if booking is enabled
        }
    );

    const hasPublicBookingSessionTypes = (bookingSessionTypesResponse?.items?.length ?? 0) > 0;
    const shouldShowBooking = showBookingPage && hasPublicBookingSessionTypes;

    const showNavOnPage = enableAboutPage || contactFormEnabled || shouldShowBooking;

    return (
        <HeaderContainer data-testid="brand-header">
            <BrandLogo brandName={brandName} />
            {showNavOnPage && <Nav brandData={brandData} />}
        </HeaderContainer>
    );
};

export default Header;
